import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';

// Import samo jezika koje koristimo
import {
    enGB,
    hr,
    cs,
    de,
    fr,
    it,
    hu,
    pl,
    ro,
    ru,
    sk,
    sl,
    es,
    nl,
    uk,
    da,
    sv,
    nn, // norveški
} from 'react-day-picker/locale';

// Pripremljena implementacija za enkripciju mail-a, pod komentarom do realizacije dekripcije na GTM-u.
// import { DATA_LAYER_EMAIL_SECRET } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/constants';

/**
 * Return the id of the location targeted by the event
 * @param  {Event} event Occured event
 * @return {String}      Id of the location
 */
export function getLocationId(event) {
    return event.target.id;
}

/**
 * Return the name of the location targeted by the event
 * @param  {Event} event Occured event
 * @return {String}      Name of the location
 */
export function getLocationName(event) {
    return event.target.attributes.name.value;
}

/**
 * Indicate if the location targeted by the event is selected
 * @param  {Event} event Occured event
 * @return {Boolean}     Is the location selected
 */
export function getLocationSelected(event) {
    return event.target.attributes['aria-checked'].value === 'true';
}

/**
 * Update searchFrom fields based on array.
 * @param  {Array} selectedUnits Array "selectedUnits"
 * @return {Object}     Updated searchForm items
 */
// Zbog nove logike sa query parametrima iz rezultata pretrage, dodali smo jos jedan argument "customSearchFromQueryData"
// koji sadrži podatke o ukupnom broju gostiju iz search forme sa rezultata pretrage, argument je dodan zbog SSR-a, na CSR-u
// koristimo direktno izvlačenje iz "window.location.search".
export function updateSearchFormDataFromSelectedUnits(selectedUnits, customSearchFromQueryData) {
    let firstLevelQueryData = {};
    if (customSearchFromQueryData) {
        firstLevelQueryData = {
            searchFormAdultsCount: Number(customSearchFromQueryData.searchFormAdultsCount) || 0,
            searchFormChildren12to17Count: Number(customSearchFromQueryData.searchFormChildren12to17Count) || 0,
            searchFormChildren4to11Count: Number(customSearchFromQueryData.searchFormChildren4to11Count) || 0,
            searchFormChildren0to3Count: Number(customSearchFromQueryData.searchFormChildren0to3Count) || 0,
        };
    } else if (windowManipulationService.isBrowserEnvironment()) {
        const queryParams = new URLSearchParams(window.location.search);
        firstLevelQueryData = {
            searchFormAdultsCount: Number(queryParams.get('searchFormAdultsCount')) || 0,
            searchFormChildren12to17Count: Number(queryParams.get('searchFormChildren12to17Count')) || 0,
            searchFormChildren4to11Count: Number(queryParams.get('searchFormChildren4to11Count')) || 0,
            searchFormChildren0to3Count: Number(queryParams.get('searchFormChildren0to3Count')) || 0,
        };
    }
    if (!Array.isArray(selectedUnits) || selectedUnits.length === 0) {
        return {
            searchFormAdultsCount: 0,
            searchFormChildren0to3Count: 0,
            searchFormChildren4to11Count: 0,
            searchFormChildren12to17Count: 0,
        };
    }
    const searchFormAdultsCount = firstLevelQueryData?.searchFormAdultsCount || selectedUnits.reduce((total, unit) => total + Number(unit.adultsCount || 0), 0);
    const searchFormChildren0to3Count = firstLevelQueryData?.searchFormChildren0to3Count || selectedUnits.reduce((total, unit) => total + Number(unit.children0to3Count || 0), 0);
    const searchFormChildren4to11Count = firstLevelQueryData?.searchFormChildren4to11Count || selectedUnits.reduce((total, unit) => total + Number(unit.children4to11Count || 0), 0);
    const searchFormChildren12to17Count = firstLevelQueryData?.searchFormChildren12to17Count || selectedUnits.reduce((total, unit) => total + Number(unit.children12to17Count || 0), 0);
    // Ako budemo želili postavit uvijek bar jednu odraslu osobu.
    // const finalSearchFormAdultsCount = searchFormAdultsCount === 0 ? 1 : searchFormAdultsCount;
    const finalSearchFormAdultsCount = searchFormAdultsCount;

    return {
        searchFormAdultsCount: finalSearchFormAdultsCount,
        searchFormChildren0to3Count,
        searchFormChildren4to11Count,
        searchFormChildren12to17Count,
    };
}

/**
 * Sum all guests from one unit.
 * @param  {Object}
 * @return {Number}
 */
export function sumAllUnitGuests(unitData) {
    const adultsCount = Number(unitData.adultsCount) || 0;
    const children0to3Count = Number(unitData.children0to3Count) || 0;
    const children4to11Count = Number(unitData.children4to11Count) || 0;
    const children12to17Count = Number(unitData.children12to17Count) || 0;
    return adultsCount + children0to3Count + children4to11Count + children12to17Count;
}

/**
 * Sum all children from one unit.
 * @param  {Object}
 * @return {Number}
 */
export function sumAllUnitChildren(unitData) {
    const children0to3Count = Number(unitData.children0to3Count) || 0;
    const children4to11Count = Number(unitData.children4to11Count) || 0;
    const children12to17Count = Number(unitData.children12to17Count) || 0;
    return children0to3Count + children4to11Count + children12to17Count;
}

/**
 * Sum all children from reservation(all units).
 * @param  {Array}
 * @return {Number}
 */
export function sumAllReservationChildren(unitsData = []) {
    return unitsData.reduce(
        (total, unit) => total
            + (unit.children0to3Count || 0)
            + (unit.children4to11Count || 0)
            + (unit.children12to17Count || 0),
        0,
    );
}

export function formatGuestsDisplayText(args) {
    const {
        numberOfPersons,
        numberOfAdults,
        numberOfChildren,
        withChildrenTemplate,
        adultsOnlyTemplate,
        splitText,
        forceChildrenTemplate,
    } = args;

    if (numberOfChildren > 0 || forceChildrenTemplate) {
        const fullText = withChildrenTemplate
            .replace('{{TOTAL_PERSONS_COUNT}}', numberOfPersons)
            .replace('{{ADULTS_COUNT}}', numberOfAdults)
            .replace('{{KIDS_COUNT}}', numberOfChildren);
        if (splitText) {
            const totalnumberOfPersonsStr = String(numberOfPersons);
            const splitIndex = fullText.indexOf(totalnumberOfPersonsStr) + totalnumberOfPersonsStr.length;
            return [
                fullText.slice(0, splitIndex),
                fullText.slice(splitIndex).trim(),
            ];
        }
        return fullText;
    }
    return adultsOnlyTemplate
        .replace('{{TOTAL_PERSONS_COUNT}}', numberOfPersons)
        .replace('{{ADULTS_COUNT}}', numberOfAdults);
}

/**
 * Return appVersion.
 */
export function getRevisionVersion() {
    return window.AppConfig.appVersion || 'Nepoznata verzija iz getRevisionVersion';
}

export const dayPickerLocales = {
    enGB, hr, cs, de, fr, it, hu, pl, ro, ru, sk, sl, es, nl, uk, da, sv, nn,
};

/**
 * Return SHA-256 hash from string
 * @param  {String} value Value to hash
 * @return {Promise<String>} SHA-256 hash
 */
async function sha256(value) {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    return Array.from(new Uint8Array(hashBuffer))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
}

/**
 * Return SHA-256 hashed email
 * @param  {String} email Email address
 * @return {Promise<String>} Hashed email
 */
export function getHashedEmail(email) {
    return sha256(email.trim().toLowerCase());
}

// Pripremljena implementacija za enkripciju mail-a, pod komentarom do realizacije dekripcije na GTM-u.
// /**
//  * Encode bytes to Base64URL
//  *
//  * @param  {Uint8Array} bytes Bytes to encode
//  * @return {String} Base64URL string
//  */
// function base64UrlEncode(bytes) {
//     let binary = '';

//     bytes.forEach((byte) => {
//         binary += String.fromCharCode(byte);
//     });

//     return btoa(binary)
//         .replace(/\+/g, '-')
//         .replace(/\//g, '_')
//         .replace(/=+$/g, '');
// }

// /**
//  * Create AES-GCM key from secret string
//  *
//  * @return {Promise<CryptoKey>} AES-GCM key
//  */
// async function getAesKey() {
//     const secretBytes = new TextEncoder().encode(DATA_LAYER_EMAIL_SECRET);
//     const keyBytes = await crypto.subtle.digest('SHA-256', secretBytes);

//     return crypto.subtle.importKey(
//         'raw',
//         keyBytes,
//         {
//             name: 'AES-GCM',
//         },
//         false,
//         ['encrypt'],
//     );
// }

// /**
//  * Return AES-GCM encrypted value
//  * Format: v1.iv.ciphertext.tag
//  *
//  * @param  {String} value Value to encrypt
//  * @return {Promise<String>} Encrypted value
//  */
// async function encrypt(value) {
//     const key = await getAesKey();
//     const iv = crypto.getRandomValues(new Uint8Array(12));
//     const encodedValue = new TextEncoder().encode(value);

//     const encryptedBuffer = await crypto.subtle.encrypt(
//         {
//             name: 'AES-GCM',
//             iv,
//             tagLength: 128,
//         },
//         key,
//         encodedValue,
//     );

//     const encryptedBytes = new Uint8Array(encryptedBuffer);

//     return [
//         'v1',
//         base64UrlEncode(iv),
//         base64UrlEncode(encryptedBytes.slice(0, -16)),
//         base64UrlEncode(encryptedBytes.slice(-16)),
//     ].join('.');
// }

/**
 * Return AES-GCM encrypted email
 *
 * @param  {String} email Email address
 * @return {Promise<String>} Encrypted email
 */
export function getEncryptedEmail(email) {
    return email;
    // Pripremljena implementacija za enkripciju mail-a, pod komentarom do realizacije dekripcije na GTM-u.
    // return encrypt(email.trim().toLowerCase());
}

/**
 * Execute callback when the browser is idle (izvršavanje kad je browserov main thread trenutno slobodan ili manje zauzet)..
 * Uses setTimeout as a fallback if requestIdleCallback is not supported.
 * Returns cleanup function for cancelling scheduled execution.
 * @param {Function} callback
 * @param {Number} timeout
 * @param {Number} fallbackTimeout
 * @return {Function|undefined}
 */
export function runDeferredInBrowser(callback, timeout = 1500, fallbackTimeout = 1000) {
    if (!windowManipulationService.isBrowserEnvironment()) {
        return undefined;
    }
    if ('requestIdleCallback' in window) {
        const idleCallbackID = window.requestIdleCallback(
            callback,
            { timeout },
        );

        return () => { window.cancelIdleCallback(idleCallbackID); };
    }
    const timeoutID = window.setTimeout(
        callback,
        fallbackTimeout,
    );

    return () => { window.clearTimeout(timeoutID); };
}
